var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',{attrs:{"inset":"","options":_vm.options,"expand":""},on:{"change":function($event){return _vm.$emit('change')}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }